export class QueryModel {
    orderByChild?: string;
    orderByKey?: boolean;
    orderByValue?: string;
    equalTo?: any;
    limitToFirst?: number;
    limitToLast?: number;
    startAt?: any;
    endAt?: any;
  }


// WEBPACK FOOTER //
// ./src/models/query.ts